import React from 'react';
import { findByText } from 'Common/Utils';
import Tooltip from 'Snippets/Tooltip';
import { IntroNotice } from './IntroNotice';
import { ClickGesture } from 'Snippets/Redundancy';

export const CustomizeRules = {
	'customize-rules-basic': [
		{
			message: <IntroNotice />,
			find: 'a[data-chaperone-trigger]',
		},
		{
			message: (
				<>
					Firstly, We have to import <b>Validator</b> from <b>formydable</b>
					...
				</>
			),
			find(target) {
				return findByText(target, 'span:Validator')[0];
			},
		},
		{
			message: (
				<>
					After we import our <b>Validator</b>, We will make our first normal{' '}
					<b>rule</b>. We will name it <b>strong_password</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:strong_password')[0];
			},
		},
		{
			message: (
				<>
					And, Our rule must contain object that has a method of <b>exe</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:exe')[0];
			},
		},
		{
			message: (
				<>
					And a property of <b>message</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:message')[0];
			},
		},
		{
			message: (
				<>
					The method of <b>exe</b> have a object parameter that contain 4
					properties: received, data, parameter, and parameter_value. but it
					depends on the rule you are making. But for now we focus on{' '}
					<b>received</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:exe')[0];
			},
		},
		{
			message: (
				<>
					<b>received</b> is the <b>value</b> of the field which we recieved...
				</>
			),
			find(target) {
				return findByText(target, 'span:received')[0];
			},
		},
		{
			message: (
				<>
					Then we make some pattern of expression to test if the <b>received</b>{' '}
					has matched the pattern...
				</>
			),
			find(target) {
				return findByText(target, 'span:test')[0];
			},
		},
		{
			message: (
				<>
					Then, We <b>return</b> the result of the <b>testing</b>. The{' '}
					<b>mechanics</b> of <b>exe</b> is that, If the <b>testing</b> was{' '}
					<b>invalid</b>, Then we must <b>return</b> <b>true</b>. But if the{' '}
					<b>testing</b> was <b>valid</b>, Then we <b>return</b> <b>false</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:return')[0];
			},
		},
		{
			message: (
				<>
					As you can observe on the <b>condition</b>. We put{' '}
					<b>received.length</b> which indicates that, this only have a chance
					to return <b>true</b>, If the <b>recieved</b> starting to have any
					value at all. So that we cannot interfer in the work of the rule{' '}
					<b>required</b>
					...
				</>
			),
			find(target) {
				return findByText(target, 'span:length')[0];
			},
		},
		{
			message: (
				<>
					We put !(not) sign on the <b>test</b>. Because of our pattern. if the{' '}
					<b>received</b> matched the <b>regular expression</b> then it will
					bring us <b>true</b>. Except our mechanics in <b>exe</b> was that, we
					only return <b>true</b> if the <b>recieved</b> is <b>invalid</b>. But
					it is still depends on your testing as long you follow the mechanics
					we are all good...
				</>
			),
			find(target) {
				return findByText(target, 'span:test')[2];
			},
		},
		{
			message: (
				<>
					Then, We will go on our property <b>message</b>. property{' '}
					<b>message</b> is a feedback message template for the user. also
					property <b>message</b> has{' '}
					<b>
						3{' '}
						<Tooltip
							variant='dark'
							offset={[0, 10]}
							message={
								<>
									<b>interpolation</b> is the insertion of something of a
									different nature into something else.
								</>
							}
							style={{ zIndex: 1000000 }}>
							<span style={{ color: '#007bff' }}>interpolations</span>
						</Tooltip>
					</b>
					. but for the time being, we only focus on the <b>:attribute</b>. The{' '}
					<b>:attribute</b> will be the place where the <b>label</b>(we
					registered on the schema) will be put on...
				</>
			),
			find(target) {
				return findByText(target, 'span:message')[0];
			},
		},
		{
			message: (
				<>
					Then, If we are all set we will put our rule(<b>strong_password</b>)
					in the <b>Validator</b> method <b>rulesExtend</b>...
				</>
			),
			find(target) {
				return findByText(target, 'span:rulesExtend')[0];
			},
		},
		{
			message: <>Now, Lets use our newly created rule...</>,
			find(target) {
				return findByText(target, 'span:strong_password')[2];
			},
		},
		{
			message: <>Then, Lets try it out...</>,
			find: '[name="pass-strong"]',
			gesture: <ClickGesture />,
			background: {
				backdropStyle: { opacity: 1 },
				highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
			},
			allowNext: false,
			allowNextOnClick: true,
			navigation: false,
		},
		{
			message: <>Let's type and see if it is working...</>,
			find: '[name="pass-strong"]',
			allowNext: false,
			allowNextOnType: true,
			navigation: false,
		},
		{
			message: (
				<>
					At least we should make valide the rule <b>strong_password</b>...
				</>
			),
			find: '[name="pass-strong"]',
			onNext({ target }) {
				const received = target.value;
				return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).+$/g.test(
					received
				);
			},
			placement: 'left',
			allowNext: false,
			allowNextOnType: true,
			navigation: false,
		},
		{
			message: (
				<>Well done! You can try the intermidiate of customizing rule...</>
			),
			find(target) {
				return findByText(target, 'a:intermidiate')[0];
			},
			isDone: true,
		},
	],
};
